import React, { useState } from 'react';
import './RelatoriosPorAluno.css';

const RelatoriosPorAluno = () => {
  const [selectedStudent, setSelectedStudent] = useState('all');
  const [selectedPeriod, setSelectedPeriod] = useState('bimestre');
  const [reportType, setReportType] = useState('completo');

  const students = [
    { id: 'joao', name: 'João Silva', turma: '9º ano A', avatar: '👦' },
    { id: 'ana', name: 'Ana Costa', turma: '9º ano A', avatar: '👧' },
    { id: 'pedro', name: 'Pedro Oliveira', turma: '9º ano B', avatar: '👦' },
    { id: 'mariana', name: 'Mariana Souza', turma: '9º ano B', avatar: '👧' },
    { id: 'lucas', name: 'Lucas Mendes', turma: '9º ano A', avatar: '👦' },
    { id: 'isabella', name: 'Isabella Costa', turma: '8º ano A', avatar: '👧' }
  ];

  const periods = [
    { id: 'semana', label: 'Última Semana' },
    { id: 'bimestre', label: 'Bimestre Atual' },
    { id: 'trimestre', label: 'Trimestre' },
    { id: 'semestre', label: 'Semestre' },
    { id: 'ano', label: 'Ano Letivo' }
  ];

  const reportTypes = [
    { id: 'completo', label: 'Relatório Completo', icon: '📊' },
    { id: 'notas', label: 'Apenas Notas', icon: '📝' },
    { id: 'frequencia', label: 'Apenas Frequência', icon: '📈' },
    { id: 'comportamento', label: 'Comportamental', icon: '🎭' }
  ];

  const generateStudentReport = (studentId) => {
    const student = students.find(s => s.id === studentId);
    if (!student) return null;

    return {
      student,
      period: selectedPeriod,
      grades: {
        matematica: [
          { bimestre: '1º', nota: 8.5, status: 'Aprovado', detalhes: 'Ótimo desempenho em álgebra' },
          { bimestre: '2º', nota: 7.8, status: 'Aprovado', detalhes: 'Dificuldade em geometria' },
          { bimestre: '3º', nota: 9.2, status: 'Aprovado', detalhes: 'Excelente progresso' },
          { bimestre: '4º', nota: 8.7, status: 'Aprovado', detalhes: 'Consistente' }
        ],
        portugues: [
          { bimestre: '1º', nota: 7.2, status: 'Aprovado', detalhes: 'Bom em interpretação' },
          { bimestre: '2º', nota: 8.1, status: 'Aprovado', detalhes: 'Melhorou na gramática' },
          { bimestre: '3º', nota: 7.9, status: 'Aprovado', detalhes: 'Criatividade em redação' },
          { bimestre: '4º', nota: 8.5, status: 'Aprovado', detalhes: 'Excelente evolução' }
        ],
        historia: [
          { bimestre: '1º', nota: 9.0, status: 'Aprovado', detalhes: 'Interesse em história brasileira' },
          { bimestre: '2º', nota: 8.8, status: 'Aprovado', detalhes: 'Participação ativa' },
          { bimestre: '3º', nota: 9.3, status: 'Aprovado', detalhes: 'Pesquisas detalhadas' },
          { bimestre: '4º', nota: 8.9, status: 'Aprovado', detalhes: 'Bom conhecimento geral' }
        ],
        ciencias: [
          { bimestre: '1º', nota: 7.5, status: 'Aprovado', detalhes: 'Dificuldade em química' },
          { bimestre: '2º', nota: 8.2, status: 'Aprovado', detalhes: 'Melhorou em biologia' },
          { bimestre: '3º', nota: 8.0, status: 'Aprovado', detalhes: 'Interesse em experimentos' },
          { bimestre: '4º', nota: 8.6, status: 'Aprovado', detalhes: 'Progresso constante' }
        ]
      },
      attendance: {
        totalAulas: 200,
        presencas: 185,
        ausencias: 15,
        justificadas: 12,
        naoJustificadas: 3,
        percentual: 92.5,
        detalhes: 'Ótima frequência, poucas ausências não justificadas'
      },
      behavior: {
        participacao: 'Excelente',
        comportamento: 'Bom',
        relacionamento: 'Ótimo',
        iniciativa: 'Muito Boa',
        responsabilidade: 'Excelente',
        observacoes: 'Aluno dedicado, participa ativamente das aulas e ajuda os colegas. Demonstra maturidade e responsabilidade.'
      },
      skills: {
        forcas: [
          'Raciocínio lógico-matemático',
          'Trabalho em equipe',
          'Criatividade',
          'Organização',
          'Liderança'
        ],
        melhorias: [
          'Oratória',
          'Gestão do tempo',
          'Autoconfiança em apresentações'
        ]
      },
      recommendations: [
        'Continuar com o excelente desempenho em matemática',
        'Buscar apoio para desenvolver habilidades de apresentação',
        'Participar mais em debates e discussões em grupo',
        'Explorar atividades extracurriculares de liderança'
      ]
    };
  };

  const currentReport = selectedStudent !== 'all' ? generateStudentReport(selectedStudent) : null;

  const calculateAverage = (grades) => {
    const validGrades = grades.filter(g => g.nota !== null);
    if (validGrades.length === 0) return 0;
    const sum = validGrades.reduce((acc, grade) => acc + grade.nota, 0);
    return (sum / validGrades.length).toFixed(1);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Aprovado': return '#10b981';
      case 'Recuperação': return '#f59e0b';
      case 'Reprovado': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getPerformanceLevel = (grade) => {
    if (grade >= 9) return { level: 'Excelente', color: '#10b981' };
    if (grade >= 7) return { level: 'Bom', color: '#3b82f6' };
    if (grade >= 5) return { level: 'Regular', color: '#f59e0b' };
    return { level: 'Baixo', color: '#ef4444' };
  };

  return (
    <div className="relatorios-aluno-container">
      <div className="relatorios-header">
        <h2>👤 Relatórios por Aluno</h2>
        <p>Acompanhe o desenvolvimento individual dos alunos</p>
      </div>

      <div className="controls-section">
        <div className="control-row">
          <div className="control-group">
            <label>Aluno:</label>
            <select 
              value={selectedStudent} 
              onChange={(e) => setSelectedStudent(e.target.value)}
              className="student-select"
            >
              <option value="all">Selecione um aluno...</option>
              {students.map(student => (
                <option key={student.id} value={student.id}>
                  {student.name} - {student.turma}
                </option>
              ))}
            </select>
          </div>

          <div className="control-group">
            <label>Período:</label>
            <div className="period-buttons">
              {periods.map(period => (
                <button
                  key={period.id}
                  className={`period-btn ${selectedPeriod === period.id ? 'active' : ''}`}
                  onClick={() => setSelectedPeriod(period.id)}
                >
                  {period.label}
                </button>
              ))}
            </div>
          </div>

          <div className="control-group">
            <label>Tipo de Relatório:</label>
            <div className="report-type-buttons">
              {reportTypes.map(type => (
                <button
                  key={type.id}
                  className={`report-type-btn ${reportType === type.id ? 'active' : ''}`}
                  onClick={() => setReportType(type.id)}
                >
                  <span className="report-icon">{type.icon}</span>
                  <span className="report-label">{type.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {selectedStudent === 'all' ? (
        <div className="students-grid">
          <div className="grid-header">
            <h3>Selecione um Aluno</h3>
            <p>Escolha um aluno para visualizar seu relatório detalhado</p>
          </div>
          <div className="students-cards">
            {students.map(student => (
              <div 
                key={student.id}
                className="student-card"
                onClick={() => setSelectedStudent(student.id)}
              >
                <div className="student-avatar">{student.avatar}</div>
                <div className="student-info">
                  <h4>{student.name}</h4>
                  <span className="student-turma">{student.turma}</span>
                </div>
                <div className="student-preview">
                  <div className="preview-stats">
                    <div className="stat">
                      <span className="stat-label">Média</span>
                      <span className="stat-value">8.4</span>
                    </div>
                    <div className="stat">
                      <span className="stat-label">Frequência</span>
                      <span className="stat-value">92%</span>
                    </div>
                  </div>
                </div>
                <div className="card-arrow">→</div>
              </div>
            ))}
          </div>
        </div>
      ) : currentReport && (
        <div className="report-content">
          <div className="report-header">
            <div className="student-header-info">
              <div className="student-large-avatar">{currentReport.student.avatar}</div>
              <div className="student-details">
                <h3>{currentReport.student.name}</h3>
                <span className="student-turma-large">{currentReport.student.turma}</span>
                <span className="report-period">Período: {periods.find(p => p.id === selectedPeriod)?.label}</span>
              </div>
            </div>
            <div className="report-actions">
              <button className="action-btn print">
                🖨️ Imprimir
              </button>
              <button className="action-btn export">
                📥 Exportar PDF
              </button>
              <button className="action-btn share">
                📤 Compartilhar
              </button>
            </div>
          </div>

          {(reportType === 'completo' || reportType === 'notas') && (
            <div className="grades-section">
              <h4>📝 Desempenho Acadêmico</h4>
              <div className="grades-grid">
                {Object.entries(currentReport.grades).map(([subject, grades]) => {
                  const average = calculateAverage(grades);
                  const performance = getPerformanceLevel(parseFloat(average));
                  
                  return (
                    <div key={subject} className="subject-card">
                      <div className="subject-header">
                        <h5>{subject.charAt(0).toUpperCase() + subject.slice(1)}</h5>
                        <div className="subject-average">
                          <span className="average-value">{average}</span>
                          <span className="average-label" style={{ color: performance.color }}>
                            {performance.level}
                          </span>
                        </div>
                      </div>
                      <div className="grades-list">
                        {grades.map((grade, index) => (
                          <div key={index} className="grade-item">
                            <span className="bimestre">{grade.bimestre}</span>
                            <span className="grade-value">{grade.nota}</span>
                            <span 
                              className="grade-status"
                              style={{ color: getStatusColor(grade.status) }}
                            >
                              {grade.status}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="subject-details">
                        <span className="details-label">Observações:</span>
                        <p className="details-text">
                          {grades[grades.length - 1]?.detalhes}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {(reportType === 'completo' || reportType === 'frequencia') && (
            <div className="attendance-section">
              <h4>📈 Frequência Escolar</h4>
              <div className="attendance-card">
                <div className="attendance-chart">
                  <div className="circular-progress">
                    <div 
                      className="progress-circle"
                      style={{ 
                        background: `conic-gradient(#10b981 ${currentReport.attendance.percentual * 3.6}deg, #e5e7eb 0deg)` 
                      }}
                    >
                      <div className="progress-center">
                        <span className="progress-value">{currentReport.attendance.percentual}%</span>
                        <span className="progress-label">Presença</span>
                      </div>
                    </div>
                  </div>
                  <div className="attendance-details">
                    <div className="attendance-stat">
                      <span className="stat-label">Total de Aulas</span>
                      <span className="stat-value">{currentReport.attendance.totalAulas}</span>
                    </div>
                    <div className="attendance-stat">
                      <span className="stat-label">Presenças</span>
                      <span className="stat-value present">{currentReport.attendance.presencas}</span>
                    </div>
                    <div className="attendance-stat">
                      <span className="stat-label">Ausências</span>
                      <span className="stat-value absent">{currentReport.attendance.ausencias}</span>
                    </div>
                    <div className="attendance-stat">
                      <span className="stat-label">Justificadas</span>
                      <span className="stat-value justified">{currentReport.attendance.justificadas}</span>
                    </div>
                  </div>
                </div>
                <div className="attendance-observation">
                  <span className="observation-label">📋 Observação:</span>
                  <p>{currentReport.attendance.detalhes}</p>
                </div>
              </div>
            </div>
          )}

          {(reportType === 'completo' || reportType === 'comportamento') && (
            <div className="behavior-section">
              <h4>🎭 Desenvolvimento Comportamental</h4>
              <div className="behavior-grid">
                <div className="behavior-card">
                  <h5>Avaliação Qualitativa</h5>
                  <div className="behavior-ratings">
                    {Object.entries(currentReport.behavior).map(([key, value]) => {
                      if (key === 'observacoes') return null;
                      return (
                        <div key={key} className="rating-item">
                          <span className="rating-label">
                            {key.charAt(0).toUpperCase() + key.slice(1)}
                          </span>
                          <div className="rating-stars">
                            {[1, 2, 3, 4, 5].map(star => {
                              let filled = false;
                              if (value.includes('Excelente')) filled = star <= 5;
                              else if (value.includes('Muito Boa') || value.includes('Ótimo')) filled = star <= 4;
                              else if (value.includes('Boa') || value.includes('Bom')) filled = star <= 3;
                              else if (value.includes('Regular')) filled = star <= 2;
                              
                              return (
                                <span key={star} className={filled ? 'star filled' : 'star'}>
                                  {filled ? '⭐' : '☆'}
                                </span>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                
                <div className="behavior-card">
                  <h5>Observações Gerais</h5>
                  <p className="behavior-observation">
                    {currentReport.behavior.observacoes}
                  </p>
                </div>
              </div>
            </div>
          )}

          {reportType === 'completo' && (
            <div className="skills-section">
              <h4>🎯 Habilidades e Desenvolvimento</h4>
              <div className="skills-grid">
                <div className="skills-card strengths">
                  <h5>💪 Pontos Fortes</h5>
                  <ul>
                    {currentReport.skills.forcas.map((skill, index) => (
                      <li key={index}>{skill}</li>
                    ))}
                  </ul>
                </div>
                <div className="skills-card improvements">
                  <h5>📈 Áreas de Melhoria</h5>
                  <ul>
                    {currentReport.skills.melhorias.map((skill, index) => (
                      <li key={index}>{skill}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}

          {reportType === 'completo' && (
            <div className="recommendations-section">
              <h4>📋 Recomendações Pedagógicas</h4>
              <div className="recommendations-card">
                <ul>
                  {currentReport.recommendations.map((rec, index) => (
                    <li key={index}>{rec}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RelatoriosPorAluno;
